import axios from 'axios';
import {api} from '../constants/api';
import Assignment from "../model/Assignment";

export const ASSIGNMENT_LIST = "ASSIGNMENT_LIST";
export const ASSIGNMENT = "ASSIGNMENT";
export const UPDATE_ASSIGNMENT = "UPDATE_ASSIGNMENT";
export const CREATE_ASSIGNMENT = "CREATE_ASSIGNMENT";

export function getAssignmentList() {
    const request = axios.get(`${api}/assignments`);
    return {
        type: ASSIGNMENT_LIST,
        payload: request
    }
}

export function getAssignment(assignmentGUID) {
    const request = axios.get(`${api}/assignments/${assignmentGUID}`);
    return {
        type: ASSIGNMENT,
        payload: request
    }
}

export function createAssignment(callback) {
    const request = axios.post(`${api}/assignments/create`, new Assignment(null, 0, "", "", ""))
        .then(response => {
            callback(Assignment.fromResponse(response.data));
        });
    return {
        type: CREATE_ASSIGNMENT,
        payload: request
    }
}

export function updateAssignment(assignment) {
    return {
        type: UPDATE_ASSIGNMENT,
        payload: assignment
    }
}

export function submitAssignment(assignment) {
    const request = axios.put(`${api}/assignments/${assignment.guid}`, assignment);
    return {
        type: ASSIGNMENT,
        payload: request
    }
}